/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_02_Detail_Amateur_2_HeadingInputs */

const en_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What changes on the course`)
};

const es_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué cambia en el campo`)
};

const de_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was sich auf dem Platz ändert`)
};

const zh_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在球场上会有什么改变`)
};

const ar_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما يتغير على الملعب`)
};

const fr_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce qui change sur le parcours`)
};

const vi_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều gì thay đổi trên sân`)
};

const sw_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinachobadilika uwanjani`)
};

const th_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อะไรเปลี่ยนไปในสนาม`)
};

const bs_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šta se mijenja na terenu`)
};

const ja_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コースで変わること`)
};

const ko_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코스에서 달라지는 것`)
};

const pt_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que muda no campo`)
};

const it_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che cosa cambia sul percorso`)
};

const sv_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad som förändras på banan`)
};

const nl_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat er op de baan verandert`)
};

const da_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad der ændrer sig på banen`)
};

const nb_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hva som endrer seg på banen`)
};

const fi_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikä muuttuu kentällä`)
};

const pl_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co zmienia się na polu`)
};

const ru_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что меняется на поле`)
};

const tr_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sahada neler değişir`)
};

const hi_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोर्स पर क्या बदलता है`)
};

const id_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang berubah di lapangan`)
};

const ms_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang berubah di padang`)
};

const cs_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co se mění na hřišti`)
};

const el_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τι αλλάζει στο γήπεδο`)
};

const he_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מה משתנה במגרש`)
};

const af_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat op die baan verander`)
};

const hu_method_content_step_02_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi változik a pályán`)
};

/**
* | output |
* | --- |
* | "What changes on the course" |
*
* @param {Method_Content_Step_02_Detail_Amateur_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_02_detail_amateur_2_heading = /** @type {((inputs?: Method_Content_Step_02_Detail_Amateur_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_02_Detail_Amateur_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "de") return de_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "zh") return zh_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "ar") return ar_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "fr") return fr_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "vi") return vi_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "sw") return sw_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "th") return th_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "bs") return bs_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "ja") return ja_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "ko") return ko_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "pt") return pt_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "it") return it_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "sv") return sv_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "nl") return nl_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "da") return da_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "nb") return nb_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "fi") return fi_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "pl") return pl_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "ru") return ru_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "tr") return tr_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "hi") return hi_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "id") return id_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "ms") return ms_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "cs") return cs_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "el") return el_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "he") return he_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "af") return af_method_content_step_02_detail_amateur_2_heading(inputs)
	if (locale === "hu") return hu_method_content_step_02_detail_amateur_2_heading(inputs)
	return en_method_content_step_02_detail_amateur_2_heading(inputs)
});